/**
 * KHIYARSA (KMD): main-menu entries — Markdown import and Export-as-KMD.
 * Rendered from AppMainMenu (marked patch there).
 */
import { MainMenu } from "@excalidraw/excalidraw/index";
import { useApp } from "@excalidraw/excalidraw/components/App";
import {
  ExportIcon,
  LoadIcon,
  MagicIcon,
} from "@excalidraw/excalidraw/components/icons";
import React from "react";

import { useSetAtom } from "../../../app-jotai";
import { kmdEditorAtom } from "../editor/atoms";
import { useEditorT } from "../editor/strings";

import { agentTemplateDialogAtom, kmdDialogAtom } from "./atoms";
import { useKmdT } from "./strings";

export const KmdMenuItems = () => {
  const t = useKmdT();
  const editorT = useEditorT();
  const app = useApp();
  const setDialog = useSetAtom(kmdDialogAtom);
  const setEditorPanel = useSetAtom(kmdEditorAtom);
  const setTemplateDialog = useSetAtom(agentTemplateDialogAtom);
  // setToast exists on the App instance but isn't part of AppClassProperties
  const toast = (message: string) =>
    (app as unknown as { setToast: (t: { message: string }) => void }).setToast(
      {
        message,
      },
    );

  const onExport = async () => {
    // the exporter lives in the code-split compiler chunk
    const { sceneToKmd } = await import("../export");
    const { markdown, warnings } = sceneToKmd(
      app.scene.getNonDeletedElements() as any,
    );
    if (!markdown) {
      toast(t("exportNoProvenance"));
      return;
    }
    const blob = new Blob([markdown], { type: "text/markdown" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "diagram.kmd.md";
    a.click();
    URL.revokeObjectURL(url);
    if (warnings.length > 0) {
      toast(
        `KMD export: ${warnings.length} warning(s) — see the comment at the top of the file`,
      );
    }
  };

  return (
    <>
      <MainMenu.Item
        icon={LoadIcon}
        onSelect={() => setEditorPanel({ open: true })}
      >
        {editorT("openEditor")}
      </MainMenu.Item>
      {/* Q6: import stays its own paste/drop/file entry point — the two
          workflows do not collapse into one */}
      <MainMenu.Item icon={LoadIcon} onSelect={() => setDialog({ open: true })}>
        {t("importMarkdown")}
      </MainMenu.Item>
      <MainMenu.Item icon={ExportIcon} onSelect={onExport}>
        {t("exportKmd")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={MagicIcon}
        onSelect={() => setTemplateDialog({ open: true })}
      >
        {t("agentTemplate")}
      </MainMenu.Item>
    </>
  );
};
